import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LazyLoadImageModule } from "ng-lazyload-image";
import { DobraZuliComponent } from "./dobra-zuli.component";

@NgModule({
  declarations: [DobraZuliComponent],
  imports: [CommonModule, LazyLoadImageModule],
  exports: [DobraZuliComponent], // Exporta o componente para ser usado em outros módulos
})
export class DobraZuliModule { }
